import CURRENCIES from '@/data/currencies';
import _ from '@/common/helpers';
import format from '@/common/format';
import utils from '../utils';

/**
 * Renders a numeric/currency cell row for display.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @param {Function} createElement
 * @returns {Array}
 */
export default function numericColumn({cachedColumn, rowData, createElement}) {
    const [value = null] = utils.getCellValues({cachedColumn, rowData});
    let children;
    let title = value;
    if (value !== null) {
        let showMinus = false;
        children = value;
        if (cachedColumn.props.approx) {
            children = format.approximateNumber(children);
        }
        if (cachedColumn.props.format === 'currency') {
            const [currencyCode = null] = utils.getCellValues(
                {
                    cachedColumn: {
                        field: cachedColumn.props.currency,
                    },
                    rowData,
                },
            );
            if (children < 0) {
                children = Math.abs(children);
                showMinus = true;
            }
            title = currencyCode || cachedColumn.props.currency;
            const currency = CURRENCIES.find(item => item.iso === currencyCode);
            children = [format.number(children, {minimumFractionDigits: 2})];
            children.unshift(createElement(
                'span',
                {
                    class: 'text-muted',
                },
                `${showMinus ? '-' : ''}${currency.sign}`,
            ));
        } else if (cachedColumn.props.format === 'number') {
            children = _.isBlank(children) || isNaN(+children)
                ? children
                : format.number(children, {minimumFractionDigits: 2});
        } else if (cachedColumn.props.format === 'percentage') {
            children = `${children}%`;
        } else if (cachedColumn.props.format === 'integer') {
            children = _.isBlank(children) || isNaN(+children)
                ? children
                : format.number(children);
        }
    } else {
        children = [utils.getEmptyCellElement(createElement)];
    }
    return [
        'div',
        {
            attrs: {title},
            class: {
                'is-numeric': true,
            },
        },
        children,
    ];
}
